export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Required field"])}
      },
      "de": {
        "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pflichtfeld"])}
      }
    }
  })
}